import docx from 'common/DynamicForm/assets/icons/FileTypes/DOCX.png';
import exe from 'common/DynamicForm/assets/icons/FileTypes/EXE.png';
import jpeg from 'common/DynamicForm/assets/icons/FileTypes/JPEG.png';
import jpg from 'common/DynamicForm/assets/icons/FileTypes/JPG.png';
import json from 'common/DynamicForm/assets/icons/FileTypes/JSON.png';
import md from 'common/DynamicForm/assets/icons/FileTypes/MD.png';
import pdf from 'common/DynamicForm/assets/icons/FileTypes/PDF.png';
import png from 'common/DynamicForm/assets/icons/FileTypes/PNG.png';
import tar from 'common/DynamicForm/assets/icons/FileTypes/TAR.png';
import txt from 'common/DynamicForm/assets/icons/FileTypes/TXT.png';
import xlsx from 'common/DynamicForm/assets/icons/FileTypes/XLSX.png';
import zip from 'common/DynamicForm/assets/icons/FileTypes/ZIP.png';
/* import pptx from 'common/DynamicForm/assets/icons/FileTypes/PPTX.png';
import mp4 from 'common/DynamicForm/assets/icons/FileTypes/MP4.png';
import mp3 from 'common/DynamicForm/assets/icons/FileTypes/MP3.png';
import rar from 'common/DynamicForm/assets/icons/FileTypes/RAR.png';
import doc from 'common/DynamicForm/assets/icons/FileTypes/DOC.png';
import xls from 'common/DynamicForm/assets/icons/FileTypes/XLS.png';
import ppt from 'common/DynamicForm/assets/icons/FileTypes/PPT.png';
import csv from 'common/DynamicForm/assets/icons/FileTypes/CSV.png';
import gif from 'common/DynamicForm/assets/icons/FileTypes/GIF.png';
import svg from 'common/DynamicForm/assets/icons/FileTypes/SVG.png';
import tiff from 'common/DynamicForm/assets/icons/FileTypes/TIFF.png';
import wav from 'common/DynamicForm/assets/icons/FileTypes/WAV.png';
import aac from 'common/DynamicForm/assets/icons/FileTypes/AAC.png';
import aiff from 'common/DynamicForm/assets/icons/FileTypes/AIFF.png';
import avi from 'common/DynamicForm/assets/icons/FileTypes/AVI.png';
import flac from 'common/DynamicForm/assets/icons/FileTypes/FLAC.png';
import mov from 'common/DynamicForm/assets/icons/FileTypes/MOV.png';
import mpeg from 'common/DynamicForm/assets/icons/FileTypes/MPEG.png';
import wmv from 'common/DynamicForm/assets/icons/FileTypes/WMV.png'; */
import defaultFile from 'common/DynamicForm/assets/icons/FileTypes/File.png';

const FileTypeIcon = (props) => {
    const { file, height } = props;

    const fileTypeSwitch = () => {
        switch (file?.type) {
            case 'application/pdf':
                return pdf;
            case 'image/jpeg':
                return jpeg;
            case 'image/jpg':
                return jpg;
            case 'text/plain':
                return txt;
            case 'image/png':
                return png;
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return xlsx;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return docx;
            case 'application/x-msdownload':
                return exe;
            case 'application/json':
                return json;
            case 'text/markdown':
                return md;
            case 'application/x-tar':
                return tar;
            case 'application/zip':
                return zip;
            default:
                return defaultFile;
        }
    };

    return <img src={fileTypeSwitch()} alt="pdf" style={{ height: height ?? '4vh', borderRadius: 4 }} />;
};

export default FileTypeIcon;
